module.exports = __webpack_public_path__ + "img/financial_chuxu.92b28a50.png";